import React from 'react';

const DrawerFooter: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className = '', children, ...props }) => (
  <footer className={`linq-drawer-footer oo-drawer-main-footer ${className}`} {...props}>
    {children}
  </footer>
);

export default DrawerFooter;
